import { Component, inject, input, signal } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';
import { IonHeader, IonToolbar, IonTitle, IonContent } from "@ionic/angular/standalone";
import { LocalizationModule } from "../../../../../../modules/localization/localization.module";
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { requiredValidator } from 'src/app/components/validators/required';
import { TextareaComponent } from "../../../../../ui/form/textarea/textarea.component";
import { ButtonComponent } from "../../../../../ui/form/button/button.component";

@Component({
  selector: 'app-rejection-reason',
  templateUrl: './rejection-reason.component.html',
  styleUrls: ['./rejection-reason.component.scss'],
  standalone: true,
  imports: [IonContent, IonTitle, IonToolbar, IonHeader, LocalizationModule, ReactiveFormsModule, TextareaComponent, ButtonComponent]
})
export class RejectionReasonComponent {
  modalService = inject(ModalService);

  form = new FormGroup({
    reason: new FormControl('', [requiredValidator("Reason")]),
  });
  forceShowErrors = signal(false);

  modalId = input<string>();

  submit() {
    this.form.updateValueAndValidity();
    if (this.form.invalid) {
      this.forceShowErrors.set(true);
      return;
    }
    this.modalService.close(this.modalId()!, this.form.controls.reason.value);
  }
}
